export default "__VITE_ASSET__Dl878n0R__"